export default __webpack_public_path__ + "static/media/min5.822cf0a9.jpg";